export default __webpack_public_path__ + "static/media/logo1.37c20868.png";